import { Component, OnInit } from '@angular/core';
import { UsefulToolsService } from '../shared/other/usefultools.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor(
    private usefultoolsservice: UsefulToolsService,
    private router: Router
  ) { }

  ngOnInit() {
    if (sessionStorage.getItem('com-session-id') === null) {
      this.usefultoolsservice.notify('error', 'Session expired. Please login again to continue');
      this.router.navigate(['/']);
    }
  }

}
